import React from 'react';

export default function Tick({ tick, count, format }) {
    return (
      <div>
        <div
          style={{
            position: 'absolute',
            marginTop: 45,
            fontSize: 13,
            textAlign: 'center',
            marginLeft: `${-(100 / count) / 2 - 1}%`,
            width: `${100 / count}%`,
            left: `${tick.percent}%`,
            color: '#B6B9BF'
          }}
        >
          {format(tick.value)}
        </div>
      </div>
    )
  }

  Tick.defaultProps = {
    format: d => d,
  }